import {useEffect, ComponentType} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {useNavigate} from 'react-router-dom';
import {getServerErrorStatus} from '../../selectors/general';
import {setServerErrorStatus} from '../../actions/general';
import {HTTP_CODE_TOO_MANY_REQUESTS, ROUTES} from '../../constants';
import {equal} from '../../utils';
import {AppDispatch} from '../../store';

const withRedirectionStrategy = <P extends object>(Component: ComponentType<P>) => {
    return (props: P) => {
        const dispatch = useDispatch<AppDispatch>();
        const navigate = useNavigate();
        const serverErrorStatus = useSelector(getServerErrorStatus);

        useEffect(() => {
            if (serverErrorStatus) {
                const route = equal(serverErrorStatus, HTTP_CODE_TOO_MANY_REQUESTS)
                    ? ROUTES.manyRequests
                    : `${ROUTES.serverError}/${serverErrorStatus}`;

                navigate(route);
                dispatch(setServerErrorStatus(null));
            }
        }, [serverErrorStatus, navigate]);

        return <Component {...props} />;
    };
};

export default withRedirectionStrategy;
